import ConfirmModal from '@components/modal/ConfirmModal';
import { Dispatch, SetStateAction, useEffect } from 'react';
import useDeleteSubmission from './_hooks/useDeleteSubmission';

const DeleteSubmissionModal: React.FC<DeleteAdminProps> = ({ id, setSubmissionToDelete }) => {
    const {
        isDeleting,
        deleteError,
        handleSubmit,
        deleteSuccess,
        prevSuccess,
    } = useDeleteSubmission(id);

    useEffect(() => {
        if (deleteSuccess && !prevSuccess) setSubmissionToDelete(null);
    }, [setSubmissionToDelete, deleteSuccess, prevSuccess]);

    return (
        <ConfirmModal
            title="Delete submission"
            description={`Are you sure you want to delete this submission?`}
            closeModal={() => setSubmissionToDelete(null)}
            handleSubmit={handleSubmit}
            isPosting={isDeleting}
            error={deleteError}
            submitText="Delete"
            submitColor="red"
        />
    );
};

interface DeleteAdminProps {
    id: number;
    setSubmissionToDelete: Dispatch<SetStateAction<number | null>>;
}

export default DeleteSubmissionModal;
